export default __webpack_public_path__ + "static/media/b4.9fad3734.jpg";